/* Freepik graphic picker logic. Externalized from snippet for caching. */
(function() {
  var PROXY_URL = 'https://freepik-proxy.medicuscaps.workers.dev';
  var pickers = {};
  
  function FreepikPicker(pickerId, uploadBoxSelector, propertyPrefix) {
    var self = this;
    self.id = pickerId;
    self.uploadBoxSelector = uploadBoxSelector;
    self.propertyPrefix = propertyPrefix;

    self.selectedGraphic = null;
    self.isInverted = false;
    self.isInitialized = false;
    self.uploadBox = null;
    self.uploadNotice = null;
    self.els = {};

    // Pagination state
    self.allResults = [];
    self.currentPage = 1;
    self.resultsPerPage = 20;
    self.hasSearched = false;
    
    self.init = function() {
      console.log('Freepik Picker #' + self.id + ': Initializing with selector:', self.uploadBoxSelector);
      var picker = document.getElementById('freepik-picker-' + self.id);
      if (!picker) {
        console.error('Freepik Picker #' + self.id + ': Could not find picker element #freepik-picker-' + self.id);
        return;
      }
      
      self.els = {
        picker: picker,
        searchInput: picker.querySelector('.freepik-picker__search-input'),
        searchBtn: picker.querySelector('.freepik-picker__search-btn'),
        results: picker.querySelector('.freepik-picker__results'),
        pagination: picker.querySelector('.freepik-picker__pagination'),
        prevBtn: picker.querySelector('.freepik-picker__page-prev'),
        nextBtn: picker.querySelector('.freepik-picker__page-next'),
        pageInfo: picker.querySelector('.freepik-picker__page-info'),
        loading: picker.querySelector('.freepik-picker__loading'),
        empty: picker.querySelector('.freepik-picker__empty'),
        selected: picker.querySelector('.freepik-picker__selected'),
        selectedImg: picker.querySelector('.freepik-picker__selected-img'),
        selectedName: picker.querySelector('.freepik-picker__selected-name'),
        removeBtn: picker.querySelector('.freepik-picker__remove'),
        preview: picker.querySelector('.freepik-picker__preview'),
        previewCircle: picker.querySelector('.freepik-picker__preview-circle'),
        previewImg: picker.querySelector('.freepik-picker__preview-img'),
        colourName: picker.querySelector('.freepik-picker__colour-name'),
        invertCheckbox: picker.querySelector('.freepik-picker__invert-checkbox'),
        inputName: picker.querySelector('.freepik-picker__input-name'),
        inputUrl: picker.querySelector('.freepik-picker__input-url'),
        inputInverted: picker.querySelector('.freepik-picker__input-inverted'),
        inputPreview: picker.querySelector('.freepik-picker__input-preview')
      };
      
      // Upload box is optional - we can work without it
      if (self.uploadBoxSelector) {
        self.uploadBox = document.querySelector(self.uploadBoxSelector);
      }

      // Always initialize core functionality
      self.moveInputsToForm();
      self.initEventListeners();
      self.watchColourChanges();

      // Optional upload box features
      if (self.uploadBox) {
        console.log('Freepik Picker #' + self.id + ': Found upload box');
        self.createUploadNotice();
        self.watchUploadBoxVisibility();
      }

      console.log('Freepik Picker #' + self.id + ': Initialized successfully');
    };
    
    self.moveInputsToForm = function() {
      // Find the product form
      var form = document.querySelector('form[action*="/cart/add"]') ||
                 document.querySelector('form.product-form') ||
                 document.querySelector('form[data-product-form]') ||
                 document.querySelector('#product-form') ||
                 document.querySelector('.shopify-product-form') ||
                 document.querySelector('product-form form');

      if (form) {
        // Move hidden inputs to form so they submit with add to cart
        [self.els.inputName, self.els.inputUrl, self.els.inputInverted, self.els.inputPreview].forEach(function(input) {
          if (input && input.parentNode !== form) {
            form.appendChild(input);
          }
        });
        console.log('Freepik Picker: Moved inputs to form');

        // Hook into form submission to ensure our properties are included
        self.hookAddToCart(form);
      } else {
        console.warn('Freepik Picker: Could not find product form for inputs');
      }
    };

    self.hookAddToCart = function(form) {
      // Hook into form submit event
      if (!form.dataset.freepikHooked) {
        form.dataset.freepikHooked = 'true';

        form.addEventListener('submit', function(e) {
          console.log('Freepik Picker: Form submit intercepted');
          self.ensureInputsInForm(form);
        });

        // Also intercept AJAX add to cart (for themes using fetch/XMLHttpRequest)
        self.interceptAjaxCart();

        console.log('Freepik Picker: Hooked into add-to-cart');
      }
    };

    self.ensureInputsInForm = function(form) {
      // Make sure our inputs are in the form and have current values
      if (self.selectedGraphic) {
        [self.els.inputName, self.els.inputUrl, self.els.inputInverted, self.els.inputPreview].forEach(function(input) {
          if (input && input.parentNode !== form) {
            form.appendChild(input);
          }
        });

        // Double-check values are set
        self.els.inputName.value = self.selectedGraphic.name;
        self.els.inputUrl.value = self.selectedGraphic.url;
        self.els.inputInverted.value = self.isInverted ? 'Yes' : 'No';
        self.els.inputPreview.value = self.selectedGraphic.thumbnail || '';

        console.log('Freepik Picker: Ensured inputs in form with values:', {
          name: self.els.inputName.value,
          url: self.els.inputUrl.value,
          inverted: self.els.inputInverted.value,
          preview: self.els.inputPreview.value
        });
      }
    };

    self.interceptAjaxCart = function() {
      // Only do this once globally
      if (window.freepikAjaxIntercepted) return;
      window.freepikAjaxIntercepted = true;

      /**
       * Collect freepik picker properties for all active pickers.
       * Returns { 'Vinyl Logo #1': 'heart', 'Vinyl Logo #1 URL': '...', ... }
       */
      function collectFreepikProperties() {
        var props = {};
        Object.keys(pickers).forEach(function(key) {
          var picker = pickers[key];
          if (picker && picker.selectedGraphic) {
            props['Vinyl Logo #' + key] = picker.selectedGraphic.name;
            props['Vinyl Logo #' + key + ' URL'] = picker.selectedGraphic.url;
            props['Vinyl Logo #' + key + ' Inverted'] = picker.isInverted ? 'Yes' : 'No';
            props['Vinyl Logo #' + key + ' Preview'] = picker.selectedGraphic.thumbnail || '';
          }
        });
        return props;
      }

      /**
       * Inject properties into the target object (handles both flat and items[0] formats).
       */
      function injectIntoJSON(data, props) {
        // YMQ format: { items: [{ id: ..., properties: {...} }] }
        if (data.items && data.items[0]) {
          if (!data.items[0].properties) data.items[0].properties = {};
          for (var p in props) {
            if (!(p in data.items[0].properties)) {
              data.items[0].properties[p] = props[p];
            }
          }
          return true;
        }
        // Flat format: { id: ..., properties: {...} }
        if (!data.properties) data.properties = {};
        for (var p in props) {
          if (!(p in data.properties)) {
            data.properties[p] = props[p];
          }
        }
        return true;
      }

      // --- Fetch interceptor (matches font-picker approach) ---
      var originalFetch = window.fetch;

      window.fetch = function(url, options) {
        var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
        var isCartAdd = urlStr.indexOf('/cart/add') !== -1;

        if (!isCartAdd || !options || !options.body) {
          return originalFetch.apply(this, arguments);
        }

        var props = collectFreepikProperties();
        if (Object.keys(props).length === 0) {
          return originalFetch.apply(this, arguments);
        }

        try {
          var body = options.body;

          // --- FormData body ---
          if (body instanceof FormData) {
            for (var k in props) {
              if (!body.has('properties[' + k + ']')) {
                body.append('properties[' + k + ']', props[k]);
              }
            }
            console.log('Freepik Picker: Added properties to FormData');
            return originalFetch.apply(this, arguments);
          }

          // --- JSON string body (YMQ items format or flat format) ---
          if (typeof body === 'string' && body.charAt(0) === '{') {
            var data = JSON.parse(body);
            injectIntoJSON(data, props);
            console.log('Freepik Picker: Added properties to JSON body');
            var newOpts = Object.assign({}, options, { body: JSON.stringify(data) });
            return originalFetch.call(this, url, newOpts);
          }

          // --- URL-encoded string body ---
          if (typeof body === 'string' && body.indexOf('=') !== -1) {
            var extra = [];
            for (var u in props) {
              var encoded = encodeURIComponent('properties[' + u + ']');
              if (body.indexOf(encoded) === -1) {
                extra.push(encoded + '=' + encodeURIComponent(props[u]));
              }
            }
            if (extra.length > 0) {
              console.log('Freepik Picker: Added properties to URL-encoded body');
              var newOpts2 = Object.assign({}, options, { body: body + '&' + extra.join('&') });
              return originalFetch.call(this, url, newOpts2);
            }
          }
        } catch (e) {
          console.error('Freepik Picker: fetch interceptor error, passing through:', e);
        }

        return originalFetch.apply(this, arguments);
      };

      // --- XHR interceptor (fallback for older themes) ---
      var originalXHROpen = XMLHttpRequest.prototype.open;
      var originalXHRSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function(method, url) {
        this._freepikUrl = url;
        return originalXHROpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function(body) {
        if (this._freepikUrl && this._freepikUrl.indexOf('/cart/add') !== -1) {
          var props = collectFreepikProperties();
          if (Object.keys(props).length > 0 && body && typeof body === 'string') {
            try {
              var parsed = JSON.parse(body);
              injectIntoJSON(parsed, props);
              console.log('Freepik Picker: Added properties to XHR JSON body');
              body = JSON.stringify(parsed);
            } catch (e) {
              // Not JSON, try form-encoded
              if (body.indexOf('=') !== -1) {
                var extra = [];
                for (var u in props) {
                  var encoded = encodeURIComponent('properties[' + u + ']');
                  if (body.indexOf(encoded) === -1) {
                    extra.push(encoded + '=' + encodeURIComponent(props[u]));
                  }
                }
                if (extra.length > 0) {
                  body += '&' + extra.join('&');
                  console.log('Freepik Picker: Added properties to XHR form-encoded body');
                }
              }
            }
          }
        }

        return originalXHRSend.call(this, body);
      };

      console.log('Freepik Picker: AJAX interception set up');
    };
    
    self.initEventListeners = function() {
      if (self.isInitialized) return;
      self.isInitialized = true;

      self.els.searchBtn.addEventListener('click', function() {
        self.search();
      });

      self.els.searchInput.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          self.search();
        }
      });

      self.els.results.addEventListener('click', function(e) {
        var item = e.target.closest('.freepik-picker__item');
        if (item) {
          var data = JSON.parse(item.getAttribute('data-graphic'));
          self.selectGraphic(data);
        }
      });

      self.els.removeBtn.addEventListener('click', function() {
        self.clearSelection();
      });

      self.els.invertCheckbox.addEventListener('change', function() {
        self.isInverted = this.checked;
        self.updateInvertedPreview();
        self.updateHiddenInputs();
      });

      // Pagination buttons — server-side pagination
      if (self.els.prevBtn) {
        self.els.prevBtn.addEventListener('click', function() {
          if (self.currentPage > 1) {
            self.currentPage--;
            self.fetchPage(self.lastQuery, self.currentPage);
          }
        });
      }

      if (self.els.nextBtn) {
        self.els.nextBtn.addEventListener('click', function() {
          if (self.currentPage < self.totalPages) {
            self.currentPage++;
            self.fetchPage(self.lastQuery, self.currentPage);
          }
        });
      }
    };
    
    // Server-side pagination state
    self.lastQuery = '';
    self.totalPages = 1;
    self.totalResults = 0;
    self.pageCache = {}; // cache keyed by "query:page"

    self.search = function() {
      var query = self.els.searchInput.value.trim();
      if (!query) return;

      self.lastQuery = query;
      self.currentPage = 1;
      self.fetchPage(query, 1);
    };

    // Fetch a single page from the server
    self.fetchPage = async function(query, page) {
      var cacheKey = query + ':' + page;

      // Check cache first
      if (self.pageCache[cacheKey]) {
        console.log('Freepik Picker: Using cached page', page, 'for:', query);
        var cached = self.pageCache[cacheKey];
        self.currentPage = page;
        self.totalPages = cached.totalPages;
        self.totalResults = cached.total;
        self.allResults = cached.results;
        self.hasSearched = true;
        self.renderResults(cached.results);
        self.updatePaginationUI();
        return;
      }

      // Show loading
      self.els.loading.style.display = 'flex';
      self.els.results.innerHTML = '';
      self.els.empty.style.display = 'none';
      if (self.els.pagination) self.els.pagination.style.display = 'none';

      try {
        var response = await fetch(PROXY_URL + '/search?q=' + encodeURIComponent(query) + '&page=' + page + '&per_page=' + self.resultsPerPage);
        var data = await response.json();

        console.log('Freepik Picker: API response page', page, ':', data);
        self.els.loading.style.display = 'none';

        var resources = data.resources || [];

        if (resources.length > 0) {
          var processed = resources.map(function(resource) {
            var thumbnail = null;
            if (resource.thumbnails && resource.thumbnails.length > 0) {
              thumbnail = resource.thumbnails[0].url || resource.thumbnails[0];
            } else if (resource.image) {
              if (typeof resource.image === 'string') {
                thumbnail = resource.image;
              } else if (resource.image.source) {
                thumbnail = resource.image.source.url || resource.image.source;
              }
            }

            return {
              id: resource.id,
              name: resource.title || resource.name || 'Graphic',
              thumbnail: thumbnail,
              url: resource.url || ('https://www.freepik.com/icon/' + resource.id),
              type: resource.type || 'icon'
            };
          }).filter(function(r) { return r.thumbnail; });

          // Update pagination state from server meta
          var meta = data.meta || {};
          self.currentPage = meta.current_page || page;
          self.totalPages = meta.last_page || 1;
          self.totalResults = meta.total || processed.length;
          self.allResults = processed;
          self.hasSearched = true;

          // Cache this page
          self.pageCache[cacheKey] = {
            results: processed,
            totalPages: self.totalPages,
            total: self.totalResults
          };

          self.renderResults(processed);
          self.updatePaginationUI();
        } else {
          self.allResults = [];
          self.totalPages = 1;
          self.els.results.innerHTML = '';
          self.els.empty.style.display = 'block';
          if (self.els.pagination) self.els.pagination.style.display = 'none';
        }
      } catch (error) {
        console.error('Freepik search error:', error);
        self.els.loading.style.display = 'none';
        self.els.empty.style.display = 'block';
      }
    };

    // Update pagination buttons and info (server-side pagination)
    self.updatePaginationUI = function() {
      if (!self.els.pagination) return;

      if (self.totalPages > 1) {
        self.els.pagination.style.display = 'flex';
        self.els.pageInfo.textContent = 'Page ' + self.currentPage + ' of ' + self.totalPages;
        self.els.prevBtn.disabled = self.currentPage <= 1;
        self.els.nextBtn.disabled = self.currentPage >= self.totalPages;
      } else {
        self.els.pagination.style.display = 'none';
      }
    };
    
    self.renderResults = function(resources) {
      // Build HTML string for speed (faster than DOM manipulation)
      // Use loading="lazy" for images below the fold, but eager for first few
      var html = resources.map(function(g, index) {
        var isSelected = self.selectedGraphic && self.selectedGraphic.id === g.id;
        var dataStr = JSON.stringify(g).replace(/'/g, '&#39;').replace(/"/g, '&quot;');
        var loading = index < 5 ? 'eager' : 'lazy';
        return '<div class="freepik-picker__item' + (isSelected ? ' selected' : '') + '" data-id="' + g.id + '" data-graphic="' + dataStr + '">' +
               '<img src="' + g.thumbnail + '" alt="' + (g.name || '').substring(0, 50) + '" loading="' + loading + '" decoding="async" />' +
               '</div>';
      }).join('');

      self.els.results.innerHTML = html;

      // Preload next page images in background
      self.preloadNextPage();
    };

    // Prefetch next page from API in background (warms cache)
    self.preloadNextPage = function() {
      if (self.currentPage < self.totalPages && self.lastQuery) {
        var nextPage = self.currentPage + 1;
        var cacheKey = self.lastQuery + ':' + nextPage;
        if (!self.pageCache[cacheKey]) {
          fetch(PROXY_URL + '/search?q=' + encodeURIComponent(self.lastQuery) + '&page=' + nextPage + '&per_page=' + self.resultsPerPage)
            .then(function(r) { return r.json(); })
            .then(function(data) {
              var resources = data.resources || [];
              var processed = resources.map(function(resource) {
                var thumbnail = null;
                if (resource.thumbnails && resource.thumbnails.length > 0) {
                  thumbnail = resource.thumbnails[0].url || resource.thumbnails[0];
                } else if (resource.image) {
                  if (typeof resource.image === 'string') thumbnail = resource.image;
                  else if (resource.image.source) thumbnail = resource.image.source.url || resource.image.source;
                }
                return { id: resource.id, name: resource.title || resource.name || 'Graphic', thumbnail: thumbnail, url: resource.url || ('https://www.freepik.com/icon/' + resource.id), type: resource.type || 'icon' };
              }).filter(function(r) { return r.thumbnail; });
              var meta = data.meta || {};
              self.pageCache[cacheKey] = { results: processed, totalPages: meta.last_page || self.totalPages, total: meta.total || self.totalResults };
              // Also preload images
              processed.forEach(function(g) { if (g.thumbnail) { var img = new Image(); img.src = g.thumbnail; } });
            })
            .catch(function() {}); // silent fail for prefetch
        }
      }
    };
    
    self.selectGraphic = function(graphic) {
      console.log('Freepik Picker: Selected graphic:', graphic.name);
      self.selectedGraphic = graphic;

      // Update selected state in grid (use data-id for speed)
      var items = self.els.results.querySelectorAll('.freepik-picker__item');
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.getAttribute('data-id') === String(graphic.id)) {
          item.classList.add('selected');
        } else {
          item.classList.remove('selected');
        }
      }

      // Show selection UI
      self.els.selectedImg.src = graphic.thumbnail;
      self.els.selectedName.textContent = graphic.name;
      self.els.selected.style.display = 'block';

      // Update hidden inputs for cart (this is critical for adding to cart)
      self.updateHiddenInputs();

      // Show preview with cap colour
      self.updatePreview();

      console.log('Freepik Picker: Cart properties set - Name:', graphic.name, 'URL:', graphic.url);
    };
    
    self.updatePreview = function() {
      if (!self.selectedGraphic || !self.els.preview) {
        if (self.els.preview) self.els.preview.style.display = 'none';
        return;
      }

      // Always show preview with selected graphic
      self.els.previewImg.src = self.selectedGraphic.thumbnail;

      // Try to get cap colour for background, use default grey if not found
      var bg = self.getBackgroundImage();
      if (bg && bg.url) {
        self.els.previewCircle.style.backgroundImage = 'url(' + bg.url + ')';
        self.els.colourName.textContent = bg.name;
      } else {
        self.els.previewCircle.style.backgroundImage = 'none';
        self.els.previewCircle.style.backgroundColor = '#e0e0e0';
        self.els.colourName.textContent = 'your cap';
      }

      self.updateInvertedPreview();
      self.els.preview.style.display = 'block';
    };
    
    self.updateInvertedPreview = function() {
      if (self.isInverted) {
        self.els.previewImg.classList.add('inverted');
      } else {
        self.els.previewImg.classList.remove('inverted');
      }
    };
    
    self.getBackgroundImage = function() {
      var colourBox = document.querySelector('[data-label="Scrub Cap Main Colour"]');
      if (colourBox) {
        var checkedInput = colourBox.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          var label = colourBox.querySelector('label[for="' + checkedInput.id + '"].ymq-options-img-label');
          if (label) {
            var style = label.getAttribute('style') || '';
            var match = style.match(/url\(([^)]+)\)/);
            if (match) {
              return {
                url: match[1].replace(/['"]/g, ''),
                name: checkedInput.value
              };
            }
          }
        }
      }
      
      var productImg = document.querySelector('.product__media img, .product-single__media img, [data-product-image], .product-featured-media img');
      if (productImg) {
        return { url: productImg.src, name: 'product' };
      }
      
      return null;
    };
    
    self.watchColourChanges = function() {
      var colourBox = document.querySelector('[data-label="Scrub Cap Main Colour"]');
      if (!colourBox) return;
      
      colourBox.addEventListener('change', function() {
        if (self.selectedGraphic) {
          self.updatePreview();
        }
      });
    };
    
    self.updateHiddenInputs = function() {
      if (!self.els.inputName || !self.els.inputUrl) {
        console.warn('Freepik Picker: Hidden inputs not found');
        return;
      }

      if (self.selectedGraphic) {
        // Set values - inputs are never disabled so they always submit
        self.els.inputName.value = self.selectedGraphic.name;
        self.els.inputUrl.value = self.selectedGraphic.url; // Freepik page link
        self.els.inputInverted.value = self.isInverted ? 'Yes' : 'No';
        self.els.inputPreview.value = self.selectedGraphic.thumbnail || '';

        console.log('Freepik Picker: ✅ Cart properties updated:', {
          name: self.els.inputName.value,
          url: self.els.inputUrl.value,
          inverted: self.els.inputInverted.value,
          preview: self.els.inputPreview.value
        });
      } else {
        // Clear values when nothing selected (but keep inputs enabled)
        self.els.inputName.value = '';
        self.els.inputUrl.value = '';
        self.els.inputInverted.value = '';
        self.els.inputPreview.value = '';
      }
    };
    
    self.clearSelection = function() {
      self.selectedGraphic = null;
      self.isInverted = false;

      // Guard against calling before initialization
      if (!self.els || !self.els.results) {
        console.warn('Freepik Picker #' + self.id + ': clearSelection called before initialization');
        return;
      }

      if (self.els.invertCheckbox) self.els.invertCheckbox.checked = false;

      self.els.results.querySelectorAll('.freepik-picker__item').forEach(function(item) {
        item.classList.remove('selected');
      });

      if (self.els.selected) self.els.selected.style.display = 'none';
      if (self.els.preview) self.els.preview.style.display = 'none';

      // Clear values but keep inputs enabled
      if (self.els.inputName) { self.els.inputName.value = ''; }
      if (self.els.inputUrl) { self.els.inputUrl.value = ''; }
      if (self.els.inputInverted) { self.els.inputInverted.value = ''; }
      if (self.els.inputPreview) { self.els.inputPreview.value = ''; }

      self.updateUploadBoxHidden();
    };
    
    self.isUploadBoxVisible = function() {
      if (!self.uploadBox) return false;
      var style = window.getComputedStyle(self.uploadBox);
      return style.display !== 'none';
    };
    
    self.updatePickerVisibility = function() {
      // Guard against calling before initialization
      if (!self.els || !self.els.picker) {
        return;
      }

      if (self.isUploadBoxVisible()) {
        self.els.picker.style.display = 'block';
      } else {
        self.els.picker.style.display = 'none';
        self.clearSelection();
      }
    };
    
    self.updateUploadBoxHidden = function() {
      if (!self.uploadBox) return;
      
      // Try multiple selectors for upload box elements (YMQ may have changed their class names)
      var uploadNewBox = self.uploadBox.querySelector('.ymq_upload_new_box') ||
                        self.uploadBox.querySelector('[class*="upload"][class*="box"]') ||
                        self.uploadBox.querySelector('.ymq_upload_new') ||
                        self.uploadBox.querySelector('[class*="ymq"][class*="upload"]');
      var helpBox = self.uploadBox.querySelector('.ymq_help_box') ||
                   self.uploadBox.querySelector('[class*="help"][class*="box"]') ||
                   self.uploadBox.querySelector('[class*="ymq"][class*="help"]');
      var optionTitle = self.uploadBox.querySelector('.ymq-option-title') ||
                       self.uploadBox.querySelector('[class*="option"][class*="title"]') ||
                       self.uploadBox.querySelector('[class*="ymq"][class*="title"]');
      if (!uploadNewBox) {
        console.warn('Freepik Picker: Could not find upload box element within', self.uploadBox);
        return;
      }
      
      if (self.selectedGraphic) {
        uploadNewBox.classList.add('freepik-picker__upload-hidden');
        if (helpBox) helpBox.classList.add('freepik-picker__upload-hidden');
        if (optionTitle) optionTitle.classList.add('freepik-picker__upload-hidden');
        if (self.uploadNotice) {
          self.uploadNotice.style.display = 'flex';
        }
        if (self.uploadBox.getAttribute('data-validate') === 'required') {
          self.uploadBox.setAttribute('data-validate', '');
          self.uploadBox.setAttribute('data-freepik-picker-override', 'true');
        }
      } else {
        uploadNewBox.classList.remove('freepik-picker__upload-hidden');
        if (helpBox) helpBox.classList.remove('freepik-picker__upload-hidden');
        if (optionTitle) optionTitle.classList.remove('freepik-picker__upload-hidden');
        if (self.uploadNotice) {
          self.uploadNotice.style.display = 'none';
        }
        if (self.uploadBox.getAttribute('data-freepik-picker-override') === 'true') {
          self.uploadBox.setAttribute('data-validate', 'required');
          self.uploadBox.removeAttribute('data-freepik-picker-override');
        }
      }
    };
    
    self.createUploadNotice = function() {
      if (!self.uploadBox) return;
      
      self.uploadNotice = document.createElement('div');
      self.uploadNotice.className = 'freepik-picker__upload-notice';
      self.uploadNotice.style.display = 'none';
      self.uploadNotice.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8e44ad" stroke-width="2"><path d="M9 12l2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg><span>Using library graphic above - no file upload needed</span>';
      
      self.uploadBox.appendChild(self.uploadNotice);
    };
    
    self.watchUploadBoxVisibility = function() {
      if (!self.uploadBox) return;
      
      var observer = new MutationObserver(function() {
        self.updatePickerVisibility();
      });
      
      observer.observe(self.uploadBox, {
        attributes: true,
        attributeFilter: ['style', 'class']
      });
      
      var parent = self.uploadBox.parentElement;
      while (parent && parent !== document.body) {
        observer.observe(parent, {
          attributes: true,
          attributeFilter: ['style', 'class']
        });
        parent = parent.parentElement;
      }
    };
    
    self.positionPicker = function() {
      if (self.els.picker && self.uploadBox && self.uploadBox.parentNode) {
        console.log('Freepik Picker #' + self.id + ': Positioning picker before upload box');
        self.uploadBox.parentNode.insertBefore(self.els.picker, self.uploadBox);
        console.log('Freepik Picker #' + self.id + ': Picker positioned successfully');
      } else {
        console.error('Freepik Picker #' + self.id + ': Could not position picker. picker:', !!self.els.picker, 'uploadBox:', !!self.uploadBox, 'parentNode:', !!self.uploadBox?.parentNode);
      }
    };
  }
  
  /**
   * Find vinyl logo upload boxes by searching for the ymq_lable span with logo keywords
   * The YMQ structure has: <span class="ymq_lable">Add #1 Logo as Vinyl Transfer</span>
   * Also supports: "1x Vinyl Transfer" with title like "Tap To Add An Image / Vector"
   */
  function findLogoUploadBox(logoNumber) {
    var num = logoNumber.toString();

    // Search patterns for the ymq_lable text
    var searchPatterns = [
      'add #' + num + ' logo as vinyl transfer',
      '#' + num + ' vinyl sticker logo',
      '#' + num + ' vinyl logo',
      'vinyl logo #' + num,
      'add logo #' + num + ' as vinyl',
      '#' + num + ' embroidery logo',
      'embroidery logo #' + num,
      // Additional patterns for different naming conventions
      num + 'x vinyl transfer',
      num + 'x vinyl',
      'add an image',
      'add image',
      'vector',
      'tap to add'
    ];

    console.log('Freepik Picker: Searching for ymq_lable with logo #' + num);

    // Find all ymq_lable spans
    var allLabels = document.querySelectorAll('.ymq_lable, span[class*="ymq_lable"], span[class*="ymq-label"]');
    console.log('Freepik Picker: Found ' + allLabels.length + ' ymq_lable elements to check');

    for (var i = 0; i < allLabels.length; i++) {
      var label = allLabels[i];
      var labelText = (label.textContent || '').toLowerCase().trim();

      for (var j = 0; j < searchPatterns.length; j++) {
        if (labelText.indexOf(searchPatterns[j]) !== -1) {
          console.log('Freepik Picker: Found logo #' + num + ' label:', labelText);

          // Find the parent options box
          var box = label.closest('.ymq-options-box') ||
                    label.closest('[class*="ymq-option"]') ||
                    label.closest('[class*="ymq_"]') ||
                    label.parentElement?.parentElement;

          if (box) {
            console.log('Freepik Picker: Found parent box for logo #' + num);
            return { box: box, label: label };
          }
        }
      }
    }

    // Also check for upload boxes that have vinyl transfer options selected
    var ymqBoxes = document.querySelectorAll('.ymq-options-box, [class*="ymq-option"]');
    for (var i = 0; i < ymqBoxes.length; i++) {
      var box = ymqBoxes[i];
      var boxText = (box.textContent || '').toLowerCase();
      var hasVinyl = boxText.indexOf('vinyl') !== -1 || boxText.indexOf('transfer') !== -1;
      var hasImage = boxText.indexOf('image') !== -1 || boxText.indexOf('vector') !== -1 || boxText.indexOf('logo') !== -1;
      var hasUpload = box.querySelector('.ymq_upload_new_box, [class*="upload"]');

      if ((hasVinyl || hasImage) && hasUpload) {
        // Check if this is the Nth upload box (for logo #1, it's the first; for #2, the second)
        var allUploadBoxes = document.querySelectorAll('.ymq-options-box:has(.ymq_upload_new_box), [class*="ymq-option"]:has([class*="upload"])');
        var boxIndex = Array.from(allUploadBoxes).indexOf(box);
        if (boxIndex === parseInt(num) - 1) {
          console.log('Freepik Picker: Found logo #' + num + ' via upload box detection');
          return { box: box, label: null };
        }
      }
    }

    // Fallback: search all elements containing logo keywords
    var allElements = document.querySelectorAll('*');
    for (var i = 0; i < allElements.length; i++) {
      var el = allElements[i];
      if (el.children.length > 0) continue;

      var text = (el.textContent || '').toLowerCase().trim();
      for (var j = 0; j < searchPatterns.length; j++) {
        if (text === searchPatterns[j] || text.indexOf(searchPatterns[j]) !== -1) {
          console.log('Freepik Picker: Found logo #' + num + ' via fallback:', text);
          var box = el.closest('.ymq-options-box') ||
                    el.closest('[class*="ymq"]') ||
                    el.parentElement?.parentElement?.parentElement;
          if (box) {
            return { box: box, label: el };
          }
        }
      }
    }

    console.log('Freepik Picker: Could not find logo #' + num + ' section');
    return null;
  }
    
  /**
   * Check if an element is visible
   */
  function isElementVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
  }
  
  /**
   * Initialize picker for a specific logo number if the section is visible
   */
  function tryInitPicker(logoNumber) {
    if (pickers[logoNumber]) return false; // Already initialized
    
    var result = findLogoUploadBox(logoNumber);
    if (result && result.box && isElementVisible(result.box)) {
      console.log('Freepik Picker: Initializing Logo #' + logoNumber + ' picker');
      
      // Create a unique ID for the box so we can target it
      var boxId = 'freepik-picker-target-' + logoNumber;
      result.box.setAttribute('id', boxId);
      
      // Get the freepik picker element
      var pickerEl = document.getElementById('freepik-picker-' + logoNumber);
      if (!pickerEl) {
        console.error('Freepik Picker: Could not find picker element #freepik-picker-' + logoNumber);
        return false;
      }
      
      // Find and hide the upload box elements within this section
      var uploadBox = result.box.querySelector('.ymq_upload_new_box, .ymq_upload_new, .ymq_upload_img_view');
      var helpBox = result.box.querySelector('.ymq_help_box');
      
      if (uploadBox) {
        uploadBox.style.display = 'none';
        console.log('Freepik Picker: Hidden upload box for logo #' + logoNumber);
      }
      if (helpBox) {
        helpBox.style.display = 'none';
      }
      
      // Insert the picker after the label/title
      if (result.label && result.label.parentElement) {
        var titleParent = result.label.closest('.ymq-option-title') || 
                          result.label.closest('[class*="title"]') ||
                          result.label.parentElement;
        if (titleParent && titleParent.parentElement) {
          titleParent.parentElement.insertBefore(pickerEl, titleParent.nextSibling);
      } else {
          result.box.insertBefore(pickerEl, result.box.firstChild);
        }
      } else {
        result.box.insertBefore(pickerEl, result.box.firstChild);
      }
      
      // Show the picker
      pickerEl.style.display = 'block';
      
      // Initialize the FreepikPicker instance
      pickers[logoNumber] = new FreepikPicker(
        logoNumber.toString(),
        '#' + boxId,
        'Vinyl Logo #' + logoNumber
      );
      pickers[logoNumber].init();
      
      console.log('Freepik Picker: Successfully initialized picker for logo #' + logoNumber);
      return true;
    }
    return false;
  }
  
  /**
   * Find YMQ option box that contains "Vinyl Transfer" option
   * This looks for the option selection UI shown in the image
   */
  function findVinylTransferOptionBox() {
    // First, look for checkboxes with "Vinyl Transfer" in the value
    var vinylCheckboxes = document.querySelectorAll('input[type="checkbox"][value*="Vinyl Transfer"], input[type="checkbox"][value*="vinyl transfer"]');
    
    for (var i = 0; i < vinylCheckboxes.length; i++) {
      var checkbox = vinylCheckboxes[i];
      var value = (checkbox.value || '').toLowerCase();
      
      // Make sure it's not embroidery
      if (value.indexOf('vinyl transfer') !== -1 && value.indexOf('embroidery') === -1) {
        // Find the parent container - look for ymq-option-value-items
        var container = checkbox.closest('[class*="ymq-option-value-items"]') ||
                       checkbox.closest('[class*="ymq-option"]') ||
                       checkbox.closest('[class*="ymq-options-box"]');
        
        if (container) {
          console.log('Freepik Picker: Found Vinyl Transfer option box via checkbox');
          return container;
        }
      }
    }
    
    // Look for containers that might have the "Tap To Add An Image / Vector To Your Scrub Cap" text
    var allContainers = document.querySelectorAll('[class*="ymq-option-value-items"], [class*="ymq-option"], [class*="ymq-options-box"], [class*="ymq"]');
    
    for (var i = 0; i < allContainers.length; i++) {
      var container = allContainers[i];
      var text = (container.textContent || '').toLowerCase();
      
      // Check if this container has the "Tap To Add" text and "Vinyl Transfer" option
      if ((text.indexOf('tap to add') !== -1 || text.indexOf('add an image') !== -1 || text.indexOf('vector') !== -1) &&
          (text.indexOf('vinyl transfer') !== -1 || text.indexOf('vinyl') !== -1)) {
        console.log('Freepik Picker: Found Vinyl Transfer option box');
        return container;
      }
    }
    
    // Fallback: Look for any YMQ option with "Vinyl Transfer" text
    var allLabels = document.querySelectorAll('.ymq_lable, span[class*="ymq_lable"], label[class*="ymq"], [class*="ymq-option-title"]');
    for (var i = 0; i < allLabels.length; i++) {
      var label = allLabels[i];
      var text = (label.textContent || '').toLowerCase();
      if (text.indexOf('vinyl transfer') !== -1 && text.indexOf('embroidery') === -1) {
        var container = label.closest('[class*="ymq-option"]') || 
                        label.closest('[class*="ymq-options-box"]') ||
                        label.closest('[class*="ymq"]');
        if (container) {
          console.log('Freepik Picker: Found Vinyl Transfer option box via label');
          return container;
        }
      }
    }
    
    return null;
  }
  
  /**
   * Check if "Vinyl Transfer" option is currently selected (for images/logos, not text)
   * Matches patterns like "1x Vinyl Transfer", "Vinyl Transfer (+£5)", etc.
   */
  function isVinylTransferSelected(container) {
    var searchScope = container || document;

    // Look for ALL checked inputs and analyze their context
    var checkedInputs = searchScope.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked');
    for (var i = 0; i < checkedInputs.length; i++) {
      var input = checkedInputs[i];
      var value = (input.value || '').toLowerCase();
      var label = input.closest('label') || document.querySelector('label[for="' + input.id + '"]');
      var labelText = (label ? label.textContent : '').toLowerCase();
      var parentContainer = input.closest('[class*="ymq-option"]') || input.closest('[class*="ymq"]');
      var parentText = parentContainer ? (parentContainer.textContent || '').toLowerCase() : '';

      // Combine all text sources
      var combinedText = value + ' ' + labelText + ' ' + parentText;

      // Check for vinyl/transfer keywords
      var hasVinyl = combinedText.indexOf('vinyl') !== -1 || combinedText.indexOf('transfer') !== -1;
      // Check for image/logo keywords (indicates it's for graphics, not text)
      var hasImageContext = combinedText.indexOf('image') !== -1 || combinedText.indexOf('vector') !== -1 ||
                            combinedText.indexOf('logo') !== -1 || combinedText.indexOf('graphic') !== -1 ||
                            combinedText.indexOf('tap to add') !== -1;
      // Exclude text-only options and embroidery
      var isNotTextOnly = combinedText.indexOf('text only') === -1 && combinedText.indexOf('text #') === -1;
      var isNotEmbroidery = combinedText.indexOf('embroidery') === -1;

      if (hasVinyl && (hasImageContext || isNotTextOnly) && isNotEmbroidery) {
        console.log('Freepik Picker: Vinyl option selected for images:', value || labelText.substring(0, 50));
        return true;
      }
    }

    // Also check for visual indicators (green border, checkmark, etc.)
    var selectedItems = searchScope.querySelectorAll('[class*="selected"], [class*="active"]');
    for (var i = 0; i < selectedItems.length; i++) {
      var item = selectedItems[i];
      var text = (item.textContent || '').toLowerCase();
      var hasVinyl = text.indexOf('vinyl') !== -1 || text.indexOf('transfer') !== -1;
      var hasImageContext = text.indexOf('image') !== -1 || text.indexOf('vector') !== -1 || text.indexOf('logo') !== -1;
      var isNotTextOnly = text.indexOf('text only') === -1;
      var isNotEmbroidery = text.indexOf('embroidery') === -1;

      if (hasVinyl && (hasImageContext || isNotTextOnly) && isNotEmbroidery) {
        var input = item.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked');
        if (input) {
          console.log('Freepik Picker: Vinyl option visually selected');
          return true;
        }
      }
    }

    return false;
  }
  
  /**
   * Show freepik picker when Vinyl Transfer is selected
   */
  function showFreepikPickerForVinylTransfer(container) {
    console.log('Freepik Picker: Showing picker for Vinyl Transfer selection, container:', container);
    
    // First try to find logo upload boxes (preferred location)
    var result1 = findLogoUploadBox('1');
    if (result1 && result1.box) {
      var style = window.getComputedStyle(result1.box);
      if (style.display !== 'none' && style.visibility !== 'hidden') {
        console.log('Freepik Picker: Found upload box, using that location');
        if (!pickers['1']) {
          tryInitPicker('1');
        } else {
          var picker1 = document.getElementById('freepik-picker-1');
          if (picker1) {
            picker1.style.display = 'block';
            console.log('Freepik Picker: Showing existing picker #1');
          }
        }
        return; // Found upload box, use that
      }
    }
    
    // If no upload box found, show picker after the option container
    var picker1 = document.getElementById('freepik-picker-1');
    if (!picker1) {
      console.error('Freepik Picker: Could not find picker element #freepik-picker-1');
      return;
    }
    
    console.log('Freepik Picker: No upload box found, showing picker near container');
    
    // Find a good insertion point - after the option value items container
    var insertPoint = container.querySelector('[class*="ymq-option-value-items"]') || container;
    
    // Make sure picker isn't already a child of this container
    if (!container.contains(picker1)) {
      // Insert after the container
      if (container.parentElement) {
        container.parentElement.insertBefore(picker1, container.nextSibling);
        console.log('Freepik Picker: Inserted picker after container');
      } else {
        container.appendChild(picker1);
        console.log('Freepik Picker: Appended picker to container');
      }
    } else {
      // Already in DOM, just move it to the right place
      if (container.parentElement && picker1.parentElement !== container.parentElement) {
        container.parentElement.insertBefore(picker1, container.nextSibling);
        console.log('Freepik Picker: Moved picker to correct location');
      }
    }
    
    picker1.style.display = 'block';
    console.log('Freepik Picker: ✅ Picker #1 is now VISIBLE');
    
    // Initialize if not already initialized
    if (!pickers['1']) {
      var boxId = 'freepik-picker-target-1';
      if (!container.id) {
        container.setAttribute('id', boxId);
      }
      pickers['1'] = new FreepikPicker('1', '#' + (container.id || boxId), 'Vinyl Logo #1');
      pickers['1'].init();
      console.log('Freepik Picker: ✅ Initialized picker #1 for Vinyl Transfer');
    } else {
      console.log('Freepik Picker: Picker #1 already initialized');
    }
    
    // Also check for picker #2
    var result2 = findLogoUploadBox('2');
    if (result2 && result2.box) {
      var style = window.getComputedStyle(result2.box);
      if (style.display !== 'none' && style.visibility !== 'hidden') {
        if (!pickers['2']) {
          tryInitPicker('2');
        } else {
          var picker2 = document.getElementById('freepik-picker-2');
          if (picker2) picker2.style.display = 'block';
        }
      }
    }
  }
  
  /**
   * Hide freepik pickers when Vinyl Transfer is deselected
   */
  function hideFreepikPickers() {
    var picker1 = document.getElementById('freepik-picker-1');
    var picker2 = document.getElementById('freepik-picker-2');
    
    if (picker1) {
      picker1.style.display = 'none';
    }
    if (picker2) {
      picker2.style.display = 'none';
    }
    
    console.log('Freepik Picker: Hidden pickers');
  }
  
  /**
   * Initialize picker when Vinyl Transfer option is selected
   */
  function checkVinylTransferSelection() {
    var vinylOptionBox = findVinylTransferOptionBox();
    
    if (vinylOptionBox && isVinylTransferSelected(vinylOptionBox)) {
      console.log('Freepik Picker: Vinyl Transfer is selected, checking for logo upload boxes');
      
      // Try to initialize pickers for logo upload boxes
      // This will show the freepik-picker when the upload boxes become visible
      if (!pickers['1']) {
        var result1 = findLogoUploadBox('1');
        if (result1 && result1.box) {
          // Make sure the upload box section is visible
          var style = window.getComputedStyle(result1.box);
          if (style.display !== 'none' && style.visibility !== 'hidden') {
            tryInitPicker('1');
          }
        } else {
          // If we can't find the upload box yet, try to show the picker near the Vinyl Transfer option
          var picker1 = document.getElementById('freepik-picker-1');
          if (picker1 && picker1.style.display === 'none') {
            // Find a good place to insert the picker (after the Vinyl Transfer option)
            var insertPoint = vinylOptionBox.querySelector('[class*="selected"], [class*="active"]') ||
                             vinylOptionBox.querySelector('input[type="radio"]:checked')?.closest('label')?.parentElement ||
                             vinylOptionBox;
            
            if (insertPoint && insertPoint.parentElement) {
              // Make sure picker isn't already a child
              if (!insertPoint.parentElement.contains(picker1)) {
                insertPoint.parentElement.insertBefore(picker1, insertPoint.nextSibling);
              }
              picker1.style.display = 'block';
              
              // Initialize the picker if not already initialized
              if (!pickers['1']) {
                var boxId = 'freepik-picker-target-1';
                vinylOptionBox.setAttribute('id', boxId);
                pickers['1'] = new FreepikPicker('1', '#' + boxId, 'Vinyl Logo #1');
                pickers['1'].init();
                console.log('Freepik Picker: Initialized picker #1 near Vinyl Transfer option');
              }
            }
          }
        }
      }
      
      if (!pickers['2']) {
        var result2 = findLogoUploadBox('2');
        if (result2 && result2.box) {
          var style = window.getComputedStyle(result2.box);
          if (style.display !== 'none' && style.visibility !== 'hidden') {
            tryInitPicker('2');
          }
        } else {
          // Similar logic for picker #2
          var picker2 = document.getElementById('freepik-picker-2');
          if (picker2 && picker2.style.display === 'none') {
            var insertPoint = vinylOptionBox.querySelector('[class*="selected"], [class*="active"]') ||
                             vinylOptionBox.querySelector('input[type="radio"]:checked')?.closest('label')?.parentElement ||
                             vinylOptionBox;
            
            if (insertPoint && insertPoint.parentElement) {
              if (!insertPoint.parentElement.contains(picker2)) {
                insertPoint.parentElement.insertBefore(picker2, insertPoint.nextSibling);
              }
              picker2.style.display = 'block';
              
              if (!pickers['2']) {
                var boxId = 'freepik-picker-target-2';
                vinylOptionBox.setAttribute('id', boxId);
                pickers['2'] = new FreepikPicker('2', '#' + boxId, 'Vinyl Logo #2');
                pickers['2'].init();
                console.log('Freepik Picker: Initialized picker #2 near Vinyl Transfer option');
              }
            }
          }
        }
      }
    } else {
      // If Vinyl Transfer is not selected, hide the pickers
      if (pickers['1']) {
        var picker1 = document.getElementById('freepik-picker-1');
        if (picker1) {
          picker1.style.display = 'none';
        }
      }
      if (pickers['2']) {
        var picker2 = document.getElementById('freepik-picker-2');
        if (picker2) {
          picker2.style.display = 'none';
        }
      }
    }
  }
  
  /**
   * Set up listeners for YMQ option changes
   */
  function setupVinylTransferListeners() {
    console.log('Freepik Picker: Setting up Vinyl Transfer listeners...');
    
    // Listen for change events on YMQ inputs - specifically for Vinyl Transfer checkbox
    document.addEventListener('change', function(e) {
      var input = e.target;
      
      // Check if this is a checkbox/radio with "Vinyl Transfer" in the value
      if (input && input.matches && input.matches('input[type="checkbox"], input[type="radio"]')) {
        var value = (input.value || '').toLowerCase();
        var label = input.closest('label') || (input.id ? document.querySelector('label[for="' + input.id + '"]') : null);
        var labelText = (label ? label.textContent : '').toLowerCase();
        
        console.log('Freepik Picker: Change event detected, value:', value, 'checked:', input.checked);
        
        if ((value.indexOf('vinyl transfer') !== -1 || value.indexOf('vinyl') !== -1) ||
            (labelText.indexOf('vinyl transfer') !== -1 || labelText.indexOf('vinyl') !== -1)) {
          
          // Check if it's checked (not embroidery)
          if (input.checked && value.indexOf('embroidery') === -1 && labelText.indexOf('embroidery') === -1) {
            console.log('Freepik Picker: ✅ Vinyl Transfer checkbox CHECKED! Showing picker...');
            
            // Find the parent container
            var optionContainer = input.closest('[class*="ymq-option-value-items"]') ||
                                 input.closest('[class*="ymq-option"]') ||
                                 input.closest('[class*="ymq-options-box"]');
            
            console.log('Freepik Picker: Found container:', !!optionContainer);
            
            if (optionContainer) {
              showFreepikPickerForVinylTransfer(optionContainer);
            } else {
              console.log('Freepik Picker: No container found, checking selection...');
              setTimeout(checkVinylTransferSelection, 100);
            }
          } else if (!input.checked) {
            // If unchecked, hide the picker
            console.log('Freepik Picker: Vinyl Transfer checkbox unchecked, hiding picker');
            hideFreepikPickers();
          }
        }
      }
    }, true); // Use capture phase to catch events early
    
    // Listen for click events on the checkbox or label (in case change doesn't fire immediately)
    document.addEventListener('click', function(e) {
      var target = e.target;
      var input = target;
      
      // If clicked on label, find the input
      if (target.matches && (target.matches('label.ymq-option-label') || target.matches('.ymq-option-label'))) {
        input = target.querySelector('input[type="checkbox"], input[type="radio"]');
        console.log('Freepik Picker: Clicked on label, found input:', !!input);
      }
      
      // If clicked on the checkbox itself or found via label
      if (input && input.matches && input.matches('input[type="checkbox"], input[type="radio"]')) {
        var value = (input.value || '').toLowerCase();
        var label = input.closest('label') || (input.id ? document.querySelector('label[for="' + input.id + '"]') : null);
        var labelText = (label ? label.textContent : '').toLowerCase();
        
        console.log('Freepik Picker: Click detected on input, value:', value.substring(0, 50), 'checked:', input.checked);
        
        if ((value.indexOf('vinyl transfer') !== -1 || value.indexOf('vinyl') !== -1) ||
            (labelText.indexOf('vinyl transfer') !== -1 || labelText.indexOf('vinyl') !== -1)) {
          
          console.log('Freepik Picker: ✅ Vinyl Transfer option CLICKED! value:', value);
          
          // Wait a bit for the checkbox state to update, then check
          setTimeout(function() {
            console.log('Freepik Picker: Checking checkbox state after click, checked:', input.checked);
            if (input.checked && value.indexOf('embroidery') === -1 && labelText.indexOf('embroidery') === -1) {
              var optionContainer = input.closest('[class*="ymq-option-value-items"]') ||
                                   input.closest('[class*="ymq-option"]') ||
                                   input.closest('[class*="ymq-options-box"]');
              
              console.log('Freepik Picker: Container found:', !!optionContainer);
              
              if (optionContainer) {
                showFreepikPickerForVinylTransfer(optionContainer);
              } else {
                console.log('Freepik Picker: No container, calling checkVinylTransferSelection');
                checkVinylTransferSelection();
              }
            } else {
              console.log('Freepik Picker: Not checked or is embroidery, hiding picker');
              hideFreepikPickers();
            }
          }, 100); // Increased delay to ensure checkbox state is updated
        }
      }
    }, true);
    
    // Watch for DOM changes that might indicate option selection
    var observer = new MutationObserver(function(mutations) {
      var shouldCheck = false;
      
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        
        // Check for checked attribute changes - specifically for Vinyl Transfer checkboxes
        if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
          var target = mutation.target;
          if (target.matches && target.matches('input[type="checkbox"], input[type="radio"]')) {
            var value = (target.value || '').toLowerCase();
            if (value.indexOf('vinyl transfer') !== -1 || value.indexOf('vinyl') !== -1) {
              if (value.indexOf('embroidery') === -1) {
                console.log('Freepik Picker: Detected Vinyl Transfer checkbox checked state change');
                if (target.checked) {
                  var container = target.closest('[class*="ymq-option-value-items"]') ||
                                 target.closest('[class*="ymq-option"]');
                  if (container) {
                    showFreepikPickerForVinylTransfer(container);
                  } else {
                    shouldCheck = true;
                  }
                } else {
                  hideFreepikPickers();
                }
              }
            }
          }
        }
        
        // Check for class changes that might indicate selection
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          var target = mutation.target;
          if (target.matches && (target.matches('[class*="ymq"]') || target.closest('[class*="ymq"]'))) {
            var text = (target.textContent || '').toLowerCase();
            if (text.indexOf('vinyl') !== -1 || text.indexOf('transfer') !== -1) {
              shouldCheck = true;
            }
          }
        }
        
        // Check for added nodes
        if (mutation.addedNodes.length > 0) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1 && node.matches && 
                (node.matches('[class*="ymq"]') || node.querySelector('[class*="ymq"]'))) {
              shouldCheck = true;
            }
          }
        }
      }
      
      if (shouldCheck) {
        setTimeout(checkVinylTransferSelection, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'class', 'style']
    });
    
    console.log('Freepik Picker: Set up Vinyl Transfer selection listeners');
    
    // Also set up direct listeners on the checkboxes themselves once they exist
    function attachDirectListeners() {
      var vinylCheckboxes = document.querySelectorAll('input[type="checkbox"][value*="Vinyl Transfer"], input[type="checkbox"][value*="vinyl transfer"]');
      console.log('Freepik Picker: Found', vinylCheckboxes.length, 'Vinyl Transfer checkboxes to attach listeners to');
      
      for (var i = 0; i < vinylCheckboxes.length; i++) {
        var checkbox = vinylCheckboxes[i];
        var value = (checkbox.value || '').toLowerCase();
        
        if (value.indexOf('vinyl transfer') !== -1 && value.indexOf('embroidery') === -1) {
          // Skip if we've already attached listeners
          if (checkbox.dataset.freepikListenerAttached === 'true') {
            continue;
          }
          checkbox.dataset.freepikListenerAttached = 'true';
          
          // Attach change listener directly
          checkbox.addEventListener('change', function(e) {
            var cb = e.target;
            console.log('Freepik Picker: ✅ Direct change listener fired! Checked:', cb.checked, 'Value:', cb.value);
            
            if (cb.checked) {
              var container = cb.closest('[class*="ymq-option-value-items"]') ||
                             cb.closest('[class*="ymq-option"]') ||
                             cb.closest('[class*="ymq-options-box"]');
              if (container) {
                showFreepikPickerForVinylTransfer(container);
              }
            } else {
              hideFreepikPickers();
            }
          });
          
          // Attach click listener directly
          checkbox.addEventListener('click', function(e) {
            var cb = e.target;
            console.log('Freepik Picker: ✅ Direct click listener fired! Value:', cb.value);
            
            setTimeout(function() {
              if (cb.checked) {
                var container = cb.closest('[class*="ymq-option-value-items"]') ||
                               cb.closest('[class*="ymq-option"]') ||
                               cb.closest('[class*="ymq-options-box"]');
                if (container) {
                  showFreepikPickerForVinylTransfer(container);
                }
              } else {
                hideFreepikPickers();
              }
            }, 50);
          });
          
          // Also attach to the label
          var label = checkbox.closest('label') || (checkbox.id ? document.querySelector('label[for="' + checkbox.id + '"]') : null);
          if (label && !label.dataset.freepikListenerAttached) {
            label.dataset.freepikListenerAttached = 'true';
            label.addEventListener('click', function(e) {
              console.log('Freepik Picker: ✅ Label clicked!');
              setTimeout(function() {
                var cb = label.querySelector('input[type="checkbox"]');
                if (cb && cb.checked) {
                  var container = cb.closest('[class*="ymq-option-value-items"]') ||
                                 cb.closest('[class*="ymq-option"]') ||
                                 cb.closest('[class*="ymq-options-box"]');
                  if (container) {
                    showFreepikPickerForVinylTransfer(container);
                  }
                }
              }, 100);
            });
          }
          
          console.log('Freepik Picker: Attached direct listeners to checkbox:', checkbox.value);
        }
      }
    }
    
    // Try to attach listeners immediately
    setTimeout(attachDirectListeners, 2000);
    
    // Also set up a more direct approach - periodically check for the checkbox
    setInterval(function() {
      // Look for ALL checkboxes/radios in YMQ containers and check their text
      var allInputs = document.querySelectorAll('[class*="ymq"] input[type="checkbox"], [class*="ymq"] input[type="radio"]');
      for (var i = 0; i < allInputs.length; i++) {
        var checkbox = allInputs[i];
        if (!checkbox.checked) continue;

        var value = (checkbox.value || '').toLowerCase();
        var label = checkbox.closest('label') || document.querySelector('label[for="' + checkbox.id + '"]');
        var labelText = label ? (label.textContent || '').toLowerCase() : '';
        var container = checkbox.closest('[class*="ymq-option"]') || checkbox.closest('[class*="ymq"]');
        var containerText = container ? (container.textContent || '').toLowerCase() : '';

        // Check if this is a vinyl transfer option (not text, not embroidery)
        var combinedText = value + ' ' + labelText + ' ' + containerText;
        var hasVinyl = combinedText.indexOf('vinyl') !== -1 || combinedText.indexOf('transfer') !== -1;
        var hasImage = combinedText.indexOf('image') !== -1 || combinedText.indexOf('vector') !== -1 || combinedText.indexOf('logo') !== -1 || combinedText.indexOf('graphic') !== -1;
        var isNotText = combinedText.indexOf('text') === -1 || combinedText.indexOf('text only') === -1;
        var isNotEmbroidery = combinedText.indexOf('embroidery') === -1;

        if (hasVinyl && (hasImage || isNotText) && isNotEmbroidery) {
          var picker1 = document.getElementById('freepik-picker-1');
          if (picker1 && picker1.style.display === 'none') {
            console.log('Freepik Picker: Found checked Vinyl option via interval check:', value || labelText.substring(0, 50));
            if (container) {
              showFreepikPickerForVinylTransfer(container);
            }
          }
          break;
        }
      }

      // Re-attach listeners in case new checkboxes were added
      attachDirectListeners();
    }, 1000); // Check every second
  }
  
  /**
   * Simple YMQ checkbox listener - listen for change events on YMQ inputs
   * This works WITH YMQ instead of fighting against it
   */
  function setupSimpleYMQListeners() {
    console.log('Freepik Picker: Setting up simple YMQ listeners');

    // Debounce function to prevent rapid-fire updates
    var debounceTimer = null;
    function debounce(fn, delay) {
      return function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(fn, delay);
      };
    }

    // Check if a vinyl image/logo option is selected
    function checkForVinylImageOption() {
      var allInputs = document.querySelectorAll('[class*="ymq"] input[type="checkbox"], [class*="ymq"] input[type="radio"]');
      var vinylImageSelected = false;
      var selectedContainer = null;

      for (var i = 0; i < allInputs.length; i++) {
        var input = allInputs[i];
        if (!input.checked) continue;

        var value = (input.value || '').toLowerCase();
        var label = input.closest('label') || document.querySelector('label[for="' + input.id + '"]');
        var labelText = label ? (label.textContent || '').toLowerCase() : '';

        // IMPORTANT: Use .ymq-options-box to get the full section container with title text
        // The [class*="ymq-option"] selector finds a smaller wrapper without the section title
        var container = input.closest('.ymq-options-box');
        var sectionText = container ? (container.textContent || '').toLowerCase() : '';

        // Check if this section is about images/vectors (not text-only)
        var isImageSection = sectionText.indexOf('image') !== -1 ||
                            sectionText.indexOf('vector') !== -1;

        // Check if vinyl transfer is selected in this section
        var hasVinyl = value.indexOf('vinyl') !== -1 || labelText.indexOf('vinyl') !== -1;
        var isNotEmbroidery = value.indexOf('embroidery') === -1 && labelText.indexOf('embroidery') === -1;

        // Only exclude if section title specifically mentions "text only" or "text #"
        // Don't exclude based on helper text like "logo with text in one placement"
        var sectionTitle = container ? (container.querySelector('.ymq_lable')?.textContent || '').toLowerCase() : '';
        var isNotTextOnlySection = sectionTitle.indexOf('text only') === -1 &&
                                   sectionTitle.indexOf('text #') === -1 &&
                                   sectionTitle.indexOf('vinyl text') === -1;

        console.log('Freepik Picker: Checking input:', value.substring(0, 40),
                    'isImageSection:', isImageSection,
                    'hasVinyl:', hasVinyl,
                    'isNotEmbroidery:', isNotEmbroidery,
                    'isNotTextOnlySection:', isNotTextOnlySection);

        if (isImageSection && hasVinyl && isNotEmbroidery && isNotTextOnlySection) {
          console.log('Freepik Picker: ✅ Found vinyl image option selected:', value || labelText.substring(0, 30));
          vinylImageSelected = true;
          selectedContainer = container;
          break;
        }
      }

      return { selected: vinylImageSelected, container: selectedContainer };
    }

    // Show/hide picker based on selection
    function updatePickerVisibility() {
      var result = checkForVinylImageOption();
      var picker1 = document.getElementById('freepik-picker-1');

      if (!picker1) return;

      if (result.selected && result.container) {
        // Show picker
        if (picker1.style.display === 'none') {
          console.log('Freepik Picker: Showing picker for vinyl image selection');

          // Find the "#1 Vinyl Transfer Size" section to position the picker ABOVE it
          var sizeSection = null;
          var allLabels = document.querySelectorAll('.ymq_lable');
          for (var i = 0; i < allLabels.length; i++) {
            var labelText = (allLabels[i].textContent || '').toLowerCase();
            if (labelText.indexOf('#1 vinyl transfer size') !== -1 ||
                labelText.indexOf('vinyl transfer size') !== -1) {
              sizeSection = allLabels[i].closest('.ymq-options-box');
              console.log('Freepik Picker: Found size section:', labelText.substring(0, 40));
              break;
            }
          }

          // Position picker before the size section if found, otherwise after the selection container
          if (sizeSection && sizeSection.parentElement) {
            sizeSection.parentElement.insertBefore(picker1, sizeSection);
            console.log('Freepik Picker: Positioned before size section');
          } else if (result.container.parentElement) {
            result.container.parentElement.insertBefore(picker1, result.container.nextSibling);
            console.log('Freepik Picker: Positioned after selection container');
          }

          picker1.style.display = 'block';

          // Initialize if not already
          if (!pickers['1']) {
            pickers['1'] = new FreepikPicker('1', null, 'Vinyl Logo #1');
            pickers['1'].init();
          }

          // Auto-search for "heart" if not already searched
          if (pickers['1'] && !pickers['1'].hasSearched) {
            console.log('Freepik Picker: Auto-searching for "heart"');
            setTimeout(function() {
              pickers['1'].search();
            }, 100);
          }
        }
      } else {
        // Hide picker
        if (picker1.style.display !== 'none') {
          console.log('Freepik Picker: Hiding picker - vinyl image not selected');
          picker1.style.display = 'none';
        }
      }
    }

    // Debounced version of updatePickerVisibility
    var debouncedUpdate = debounce(updatePickerVisibility, 200);

    // Listen for changes on YMQ container using event delegation
    document.body.addEventListener('change', function(e) {
      var target = e.target;
      if (target.type === 'checkbox' || target.type === 'radio') {
        var isYMQ = target.closest('[class*="ymq"]');
        if (isYMQ) {
          console.log('Freepik Picker: YMQ input changed:', target.value);
          debouncedUpdate();
        }
      }
    });

    // Also listen for click events (YMQ sometimes uses these)
    document.body.addEventListener('click', function(e) {
      var target = e.target;
      var ymqItem = target.closest('.ymq-option-value-item, [class*="ymq-option"]');
      if (ymqItem) {
        // Delay to let YMQ update its state first
        setTimeout(debouncedUpdate, 100);
      }
    });

    // Initial check after YMQ loads
    setTimeout(updatePickerVisibility, 2000);
    setTimeout(updatePickerVisibility, 4000);

    console.log('Freepik Picker: Simple listeners set up');
  }

  // Initialize when DOM is ready - use requestIdleCallback for non-blocking init
  function deferredInit() {
    // Use requestIdleCallback if available, otherwise setTimeout
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function() {
        console.log('Freepik Picker: Deferred init via requestIdleCallback');
        setTimeout(setupSimpleYMQListeners, 500);
      }, { timeout: 2000 });
    } else {
      setTimeout(function() {
        console.log('Freepik Picker: Deferred init via setTimeout');
        setupSimpleYMQListeners();
      }, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', deferredInit);
  } else {
    deferredInit();
  }

})();


/* ---- second init block ---- */
(function() {
  'use strict';

  // Only run if Horizon's variant-picker exists (no YMQ)
  if (document.querySelector('[class*="ymq"]')) return;

  var picker1 = document.getElementById('freepik-picker-1');
  var picker2 = document.getElementById('freepik-picker-2');
  if (!picker1) return;

  console.log('Freepik Picker [Horizon]: Initializing variant-picker compatibility');

  function isVinylOption(value) {
    var v = (value || '').toLowerCase();
    return (v.indexOf('vinyl') !== -1 || v.indexOf('transfer') !== -1) &&
           v.indexOf('embroidery') === -1 &&
           v.indexOf('no ') !== 0 && v !== 'no' && v.indexOf('none') !== 0;
  }

  function isTextOnlyOption(value) {
    var v = (value || '').toLowerCase();
    return v.indexOf('text only') !== -1 || v.indexOf('text #') !== -1;
  }

  function scanHorizonVariants() {
    var variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;

    var fieldsets = variantPicker.querySelectorAll('fieldset');
    var vinylFieldset = null;
    var vinylSelected = false;

    for (var i = 0; i < fieldsets.length; i++) {
      var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (!checked) continue;

      var val = checked.value || '';
      if (isVinylOption(val) && !isTextOnlyOption(val)) {
        vinylSelected = true;
        vinylFieldset = fieldsets[i];
        console.log('Freepik Picker [Horizon]: Vinyl option selected:', val);
        break;
      }
    }

    if (vinylSelected && vinylFieldset) {
      // Position picker after the vinyl fieldset
      if (picker1.parentElement !== vinylFieldset.parentElement ||
          picker1.previousElementSibling !== vinylFieldset) {
        vinylFieldset.parentElement.insertBefore(picker1, vinylFieldset.nextSibling);
      }
      picker1.style.display = 'block';

      // Initialize picker if needed
      if (typeof window.freepikPickers !== 'undefined' && !window.freepikPickers['1']) {
        // Trigger init by dispatching a synthetic check
      }
      console.log('Freepik Picker [Horizon]: Showing picker below vinyl option');
    } else {
      picker1.style.display = 'none';
      if (picker2) picker2.style.display = 'none';
      console.log('Freepik Picker [Horizon]: No vinyl selected, hiding pickers');
    }
  }

  // Listen for change events on variant picker radio inputs
  document.addEventListener('change', function(e) {
    var input = e.target;
    if (!input.matches || !input.matches('variant-picker input[type="radio"], variant-picker select')) return;
    console.log('Freepik Picker [Horizon]: Variant changed:', input.value);
    setTimeout(scanHorizonVariants, 50);
  }, true);

  // Also listen for Horizon's custom variant events
  document.addEventListener('variant:selected', function() {
    setTimeout(scanHorizonVariants, 100);
  });
  document.addEventListener('variant:update', function() {
    setTimeout(scanHorizonVariants, 200);
  });

  // Initial scan
  setTimeout(scanHorizonVariants, 1000);
  setTimeout(scanHorizonVariants, 3000);

  console.log('Freepik Picker [Horizon]: Listeners set up');
})();
